import React from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationTracker() {
  const location = useLocation();

  React.useEffect(() => {
    // Navigation tracking placeholder
  }, [location]);

  return null;
}
